import { css } from 'lit';
export const toggletipStyles = css `
    :host {
        display: inline-block;
    }
    .hlx-toggletip {
        display: inline;
    }
    .hlx-toggletip-trigger {
        padding: 0;
    }
    .default-trigger-icon {
        position: relative;
        margin: 0 var(--hlx-spacing-xs);
        bottom: -1px;
        color: var(--hlx-button-color-tertiary-brand-default);
    }
    .click-target {
        position: absolute;
        height: calc(14px + var(--hlx-spacing-xs));
        left: 0;
        top: calc(var(--hlx-spacing-xs) / -2);
        width: 100%;
    }

    .hlx-toggletip-trigger,
    .hlx-toggletip-close-button {
        background-color: transparent;
        line-height: 10px;
        cursor: pointer;
        border: none;
    }

    .hlx-toggletip-trigger:disabled .hlx-toggletip-close-button:disabled {
        pointer-events: none;
    }

    .hlx-toggletip-trigger:focus {
        outline: none;
    }

    .hlx-toggletip-trigger:focus-visible hlx-icon,
    .hlx-toggletip-close-button:focus-visible {
        border-radius: var(--hlx-radius-xs);
        outline: 2px solid var(--hlx-color-brand-default);
        outline-offset: 2px;
    }
    .hlx-toggletip-trigger:hover {
        color: var(--hlx-button-color-tertiary-brand-hover);
    }
    .hlx-toggletip-close-button {
        padding: var(--hlx-spacing-xs);
        margin-top: calc(-1 * var(--hlx-spacing-xs));
        margin-right: calc(-1 * var(--hlx-spacing-xs));
        color: var(--hlx-button-color-tertiary-inverted-default);
    }
    .hlx-toggletip-close-button:hover {
        color: var(--hlx-button-color-tertiary-inverted-hover);
    }
    .hlx-toggletip-body {
        width: max-content;
        position: absolute;
        top: 0;
        left: 0;
        display: block;
        background-color: var(--hlx-tooltip-background-color);
        color: var(--hlx-tooltip-color);
        max-width: min(var(--hlx-tooltip-max-width), 100vw);
        font-family: var(--hlx-text-font-family-sans-serif);
        font-size: var(--hlx-tooltip-font-size);
        font-weight: var(--hlx-tooltip-font-weight);
        line-height: var(--hlx-tooltip-line-height);
        line-break: auto;
        word-break: break-word;
        padding: var(--hlx-spacing-md) var(--hlx-spacing-lg);
        border-radius: var(--hlx-tooltip-border-radius);
        z-index: 1070;
        user-select: none;
    }

    .hlx-toggletip-inverted .hlx-toggletip-body {
        background-color: var(--hlx-background-color-default);
        color: var(--hlx-text-color-default);
    }

    .hlx-toggletip-inverted .hlx-toggletip-arrow {
        background-color: var(--hlx-background-color-default);
    }

    .hlx-toggletip-inverted .hlx-toggletip-close-button {
        color: var(--hlx-button-color-tertiary-dark-default);
    }

    .hlx-toggletip-inverted .hlx-toggletip-close-button:hover {
        color: var(--hlx-button-color-tertiary-dark-hover);
    }

    .hlx-toggletip-inverted .default-trigger-icon {
        color: var(--hlx-button-color-tertiary-inverted-default);
    }

    .hlx-toggletip-body-container {
        display: flex;
        align-items: baseline;
    }

    .hlx-toggletip-fadeout .hlx-toggletip-body {
        animation: fadeout var(--hlx-tooltip-animation-duration) linear forwards;
    }

    .hlx-toggletip-fadein .hlx-toggletip-body {
        animation: fadein var(--hlx-tooltip-animation-duration) linear forwards;
    }
    .hlx-toggletip-open .hlx-toggletip-body {
        opacity: 1;
    }
    .hlx-toggletip-removed .hlx-toggletip-body {
        display: none;
    }

    .hlx-toggletip-arrow {
        position: absolute;
        width: 8px;
        height: 8px;
        background-color: var(--hlx-tooltip-background-color);
        transform: rotate(45deg);
        pointer-events: none;
    }

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 0.9;
        }
    }

    @keyframes fadeout {
        from {
            opacity: 0.9;
        }
        to {
            opacity: 0;
        }
    }

    @media (prefers-reduced-motion) {
        .hlx-toggletip-fadeout .hlx-toggletip-body {
            opacity: 0;
        }
    }
`;
//# sourceMappingURL=toggletip.styles.js.map